/* Native options stay in Shopify order. Single is a storefront-only choice. */
(() => {
  customElements.whenDefined('variant-selects').then(() => {
    if (customElements.get('kosiner-gauge-selects')) return;
    const Base = customElements.get('variant-selects');
    class KosinerGaugeSelects extends Base {
      connectedCallback() {
        super.connectedCallback();
        this.placeSizeGuide();
      }
      placeSizeGuide() {
        const productInfo = this.closest('product-info');
        const secondOption = this.querySelector('[data-ks-position="2"] .product-form__input');
        const label = secondOption?.querySelector('.form__label');
        const shell = productInfo?.querySelector('.kosiner-size-guide-shell');
        const trigger = shell?.querySelector('.kosiner-size-guide-trigger');
        if (!label || !trigger || secondOption.querySelector('.ks-option-guide-row')) return;
        const row = document.createElement('div');
        row.className = 'ks-option-guide-row';
        row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;margin-bottom:8px;';
        label.parentNode.insertBefore(row, label);
        label.style.cssText = 'flex:1 1 auto;min-width:0;margin:0;';
        trigger.style.cssText = 'display:flex;align-items:center;justify-content:flex-end;flex:0 0 auto;width:auto;max-width:none;margin:0;padding:0;white-space:nowrap;';
        row.append(label, trigger);
        shell.remove();
      }

      nativeWrappers() {
        return Array.from(this.querySelectorAll('[data-ks-position]')).sort((a, b) => Number(a.dataset.ksPosition) - Number(b.dataset.ksPosition));
      }
      readControl(wrapper) {
        return wrapper.querySelector('select')?.value ?? wrapper.querySelector('input[type="radio"]:checked')?.value;
      }
      updateOptions() {
        this.options = this.nativeWrappers().map(wrapper => this.readControl(wrapper));
      }
      updateVariantText() {
        this.nativeWrappers().forEach((wrapper, index) => {
          const label = wrapper.querySelector('.form__label-value');
          if (label) label.textContent = this.options[index] || '';
        });
      }
      updateVariantStatuses() {
        this.nativeWrappers().forEach((wrapper, index) => {
          const availableValues = this.getVariantData().filter(variant =>
            variant.available && variant.options.every((value, other) => other === index || value === this.options[other])
          ).map(variant => variant.options[index]);
          this.setInputAvailability(Array.from(wrapper.querySelectorAll('input[type="radio"], option')), availableValues);
        });
      }
    }
    customElements.define('kosiner-gauge-selects', KosinerGaugeSelects);
  });
})();
